import { io, Socket } from 'socket.io-client'
import Cookies from 'js-cookie'
import { LLC_ACCESS_TOKEN } from '@configs'

let socketInstance: Socket | null = null

export const getSocketInstance = (): Socket | null => {
  const token = Cookies.get(LLC_ACCESS_TOKEN)

  if (token && !socketInstance) {
    const URL =
      process.env.REACT_APP_PUBLIC_API_URL &&
      process.env.REACT_APP_PUBLIC_API_URL.replace('/api', '/room')
    socketInstance = io(URL as string, {
      transports: ['websocket'],
      auth: {
        token: `Bearer ${token}`,
      },
    })
  }

  return socketInstance
}
